import { Button } from "$components/button/button";
import { ButtonGroup, makeStyles } from "@material-ui/core";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles((theme) => ({
  button: {
    "&:hover": {
      backgroundColor: theme.palette.grey[400],
    },
  },
}));

interface EditSwitchProps {
  editable: boolean;
  disabled: boolean;
  toggleEdit: (editable: boolean) => void;
}

export const EditSwitch = ({
  editable,
  disabled,
  toggleEdit,
}: EditSwitchProps) => {
  const classes = useStyles();

  return (
    <ButtonGroup
      variant="contained"
      aria-label="edit mode toggle"
      disabled={disabled}
      disableFocusRipple
      disableRipple
      disableElevation
    >
      <Button
        className={editable && classes.button}
        color={!editable ? "primary" : "secondary"}
        onClick={() => toggleEdit(false)}
      >
        {editable ? (
          <FormattedMessage
            id="invoicing.invoice.editToggle.read"
            defaultMessage="Read"
          />
        ) : (
          <FormattedMessage
            id="invoicing.invoice.editToggle.reading"
            defaultMessage="Reading"
          />
        )}
      </Button>
      <Button
        className={!editable && classes.button}
        color={editable ? "primary" : "secondary"}
        onClick={() => toggleEdit(true)}
      >
        {editable ? (
          <FormattedMessage
            id="invoicing.invoice.editToggle.editing"
            defaultMessage="Editing"
          />
        ) : (
          <FormattedMessage
            id="invoicing.invoice.editToggle.edit"
            defaultMessage="Edit"
          />
        )}
      </Button>
    </ButtonGroup>
  );
};
